
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class DealService extends CommonService {
	async getDeals(params?: { [key: string]: string | boolean }) {
		const query = generateQueryParams(params);
		return await this.get(`deals/?${query}`);
	}
	async getDealDetails(id: string) {
		return await this.get(`deals/${id}`)
	}
	async createDeals(parmas: { [key: string]: boolean | string }) {
		return await this.post('deals', parmas)
	}
	async updateDeals(id: string, params: { [key: string]: boolean | string }) {
		return await this.put(`deals/${id}`, params)
	}
	
}
export const dealService = new DealService();
